<template>
    <div class="header">
        <!-- 折叠按钮 -->
        <div class="collapse-btn" @click="collapseChange">
            <i v-if="!collapse" class="el-icon-s-fold"></i>
            <i v-else class="el-icon-s-unfold"></i>
        </div>
        <div class="logo">后台管理系统</div>
        <div class="header-right">
            <div class="header-user-con">
                <!-- 样式风格 -->
               <div class="btn-theme">
                   <el-tooltip content="主题风格" placement="bottom">
                       <el-color-picker v-model="theme" class="theme-picker" size="small" popper-class="theme-picker-dropdown" />
                   </el-tooltip>
               </div>
                <!-- 全屏显示 -->
                <div class="btn-fullscreen" @click="handleFullScreen">
                    <el-tooltip effect="dark" :content="fullscreen ? `取消全屏` : `全屏`" placement="bottom">
                        <i class="el-icon-rank"></i>
                    </el-tooltip>
                </div>
                <!-- 消息中心 -->
                <div class="btn-bell">
                    <!-- <el-tooltip effect="dark" :content="message ? `有${message}条未读消息` : `消息中心`" placement="bottom">
                            
                    </el-tooltip>
                    <span class="btn-bell-badge" v-if="message"></span> -->
                    <router-link to="/im/new">
                        <el-badge :hidden="message == 0" :value="message" class="item">
                            <i class="el-icon-bell"></i>
                        </el-badge>
                    </router-link>
                </div>
                <!-- 用户头像 -->
                <div class="user-avator">
                    <img :src="userInfo.userHeader" alt="" v-if="userInfo.userHeader" />
                </div>
                <!-- 用户名下拉菜单 -->
                <el-dropdown class="user-name" trigger="click" @command="handleCommand">
                    <span class="el-dropdown-link">
                        {{ userInfo.userName }}
                        <i class="el-icon-caret-bottom"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item divided command="logout">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
    </div>
</template>

<script>
import bus from '@/components/common/bus';
import { mapMutations, mapState } from 'vuex';
import { logout } from '@/api/user.js';
import { clearStorage } from '@/utils/index.js';

const version = require('element-ui/package.json').version; // element-ui version from node_modules
const ORIGINAL_THEME = '#ffffff'; // default color #3c8dbc
export default {
    data() {
        return {
            collapse: false,
            fullscreen: false,
            name: 'admin',
            message: 0,
            openDrawer: false,
            chalk: '', // content of theme-chalk css
            theme: ORIGINAL_THEME
        };
    },
    computed: {
        ...mapState(['userInfo']),
        ...mapState('newChat',['chatList']),
        username() {
            let username = localStorage.getItem('ms_username');
            return username ? username : this.name;
        }
    },
    watch: {
        chatList:{
            handler(val, oldVal){
                // console.log(val, oldVal);
                let count = 0;
                for (const iterator of val) {
                    count += iterator.unReadNums
                }
                // console.log(count)
                this.message = count;
            },deep: true
        },
        theme:{
            handler(val, oldVal){

                // 这里的 oldVal 是空的一直报错影响其他的代码调试了，先给错误抛出了

                try {
                    if (typeof val !== 'string') return;
                    const themeCluster = this.getThemeCluster(val.slice(1));
                    const originalCluster = this.getThemeCluster(oldVal.slice(1));
                    const getHandler = (variable, id) => {
                        return () => {
                            const originalCluster = this.getThemeCluster(ORIGINAL_THEME.slice(1));
                            const newStyle = this.updateStyle(this[variable], originalCluster, themeCluster);

                            let styleTag = document.getElementById(id);
                            if (!styleTag) {
                                styleTag = document.createElement('style');
                                styleTag.setAttribute('id', id);
                                document.head.appendChild(styleTag);
                            }
                            styleTag.innerText = newStyle;
                        };
                    };

                    const chalkHandler = getHandler('chalk', 'chalk-style');

                    if (!this.chalk) {
                        const url = `https://unpkg.com/element-ui@${version}/lib/theme-chalk/index.css`;
                        this.getCSSString(url, chalkHandler, 'chalk');
                    } else {
                        chalkHandler();
                    }

                    const styles = [].slice.call(document.querySelectorAll('style')).filter((style) => {
                        const text = style.innerText;
                        return new RegExp(oldVal, 'i').test(text) && !/Chalk Variables/.test(text);
                    });
                    styles.forEach((style) => {
                        const { innerText } = style;
                        if (typeof innerText !== 'string') return;
                        style.innerText = this.updateStyle(innerText, originalCluster, themeCluster);
                    });
                    this.$message({
                        message: '主题切换成功',
                        type: 'success'
                    });
                }catch (e) {

                }
            },
            immediate: true
        },
        // theme(val, oldVal) {
            
        // }
    },
    created() {
        bus.$on('header-btn', () => {
            this.collapseChange()
        });
        bus.$on('open-btn', () => {
            this.collapse = false
            bus.$emit('collapse', this.collapse);
        })
        bus.$on('close-btn', () => {
            this.collapse = true
            bus.$emit('collapse', this.collapse);
        })
    },
    methods: {
        ...mapMutations(['setTheme']),
        // 用户名下拉菜单选择事件
        handleCommand(command) {
            if (command == 'logout') {
                logout({ userId: this.userInfo.id }).then((res) => {
                    if (res.success) {
                        this.$message({
                            message: '退出成功',
                            type: 'success',
                            showClose: true,
                            duration: 2000
                        });
                    }
                    clearStorage();
                    this.$router.push('/login');
                });
            }
        },
        // 侧边栏折叠
        collapseChange() {
            this.collapse = !this.collapse;
            bus.$emit('collapse', this.collapse);
        },
        // 全屏事件
        handleFullScreen() {
            let element = document.documentElement;
            if (this.fullscreen) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                if (element.requestFullscreen) {
                    element.requestFullscreen();
                } else if (element.webkitRequestFullScreen) {
                    element.webkitRequestFullScreen();
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if (element.msRequestFullscreen) {
                    // IE11
                    element.msRequestFullscreen();
                }
            }
            this.fullscreen = !this.fullscreen;
        },
        updateStyle(style, oldCluster, newCluster) {
            let newStyle = style;
            oldCluster.forEach((color, index) => {
                newStyle = newStyle.replace(new RegExp(color, 'ig'), newCluster[index]);
            });
            return newStyle;
        },

        getCSSString(url, callback, variable) {
            const xhr = new XMLHttpRequest();
            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4 && xhr.status === 200) {
                    this[variable] = xhr.responseText.replace(/@font-face{[^}]+}/, '');
                    callback();
                }
            };
            xhr.open('GET', url);
            xhr.send();
        },

        getThemeCluster(theme) {
            const tintColor = (color, tint) => {
                let red = parseInt(color.slice(0, 2), 16);
                let green = parseInt(color.slice(2, 4), 16);
                let blue = parseInt(color.slice(4, 6), 16);

                if (tint === 0) {
                    // when primary color is in its rgb space
                    return [red, green, blue].join(',');
                } else {
                    red += Math.round(tint * (255 - red));
                    green += Math.round(tint * (255 - green));
                    blue += Math.round(tint * (255 - blue));

                    red = red.toString(16);
                    green = green.toString(16);
                    blue = blue.toString(16);

                    return `#${red}${green}${blue}`;
                }
            };

            const shadeColor = (color, shade) => {
                let red = parseInt(color.slice(0, 2), 16);
                let green = parseInt(color.slice(2, 4), 16);
                let blue = parseInt(color.slice(4, 6), 16);

                red = Math.round((1 - shade) * red);
                green = Math.round((1 - shade) * green);
                blue = Math.round((1 - shade) * blue);

                red = red.toString(16);
                green = green.toString(16);
                blue = blue.toString(16);

                return `#${red}${green}${blue}`;
            };

            const clusters = [theme];
            for (let i = 0; i <= 9; i++) {
                clusters.push(tintColor(theme, Number((i / 10).toFixed(2))));
            }
            clusters.push(shadeColor(theme, 0.1));
            return clusters;
        }
    },
    mounted() {
        if (document.body.clientWidth < 800) {
            this.collapseChange();
        }
    }
};
</script>
<style scoped>
.header {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 50px;
    font-size: 16px;
    color: #333;
}
.collapse-btn {
    float: left;
    padding: 0 22px;
    cursor: pointer;
    line-height: 50px;
}
.header .logo {
    float: left;
    width: 250px;
    line-height: 50px;
}
.header-right {
    float: right;
    padding-right: 20px;
}
.header-user-con {
    display: flex;
    height: 50px;
    align-items: center;
}
.btn-fullscreen {
    transform: rotate(45deg);
    margin-right: 5px;
    margin-top: 0px;
    font-size: 28px;
}

.btn-more {
    display: flex;
    align-items: center;
    margin-left: 10px;
}
.btn-theme {
    width: 40px;
    height: 35px;
    margin-top: 5px;
}
.btn-bell,
.btn-fullscreen {
    position: relative;
    width: 30px;
    text-align: center;
    border-radius: 15px;
    cursor: pointer;
    margin-top: 3px;
}
.btn-bell-badge {
    position: absolute;
    right: 0;
    top: -2px;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    background: #f56c6c;
    color: #333;
}
.btn-bell .el-icon-bell {
    color: #333;
}
.user-name {
    margin-left: 0px;
}
.user-avator {
    margin-left: 5px;
    margin-right: 10px;
}
.user-avator img {
    display: block;
    width: 28px;
    height: 28px;
    border-radius: 50%;
}
.el-dropdown-link {
    color: #333;
    cursor: pointer;
}
.el-dropdown-menu__item {
    text-align: center;
}

.drawer-content {
    padding: 0 20px;
}

::v-deep .el-color-picker__trigger {
    border: none;
}
</style>
